module.exports = __webpack_public_path__ + "static/media/pic9.569628e5.jpg";